import React from 'react';
import { Hub } from '../../components/Hub';

const hubData = {
  meta: {
    title: 'Boss & CEO Billionaire Romance Books 2025 | NanoReads',
    metaDescription:
      'Read boss & CEO billionaire romance books online—dominant CEOs, fake-fiancée contracts, and forbidden office affairs. Curated 2025 reads, updated 9 June 2025.',
    canonical: 'https://nanoreads.com/hub/boss-ceo-romance',
    openGraph: {
      og_title: 'Boss & CEO Billionaire Romance Books 2025 | NanoReads',
      og_description:
        'Read boss & CEO billionaire romance books online—dominant CEOs, fake-fiancée contracts, and forbidden office affairs. Curated 2025 reads, updated 9 June 2025.',
      og_url: 'https://nanoreads.com/hub/boss-ceo-romance',
      og_image: 'https://nanoreads.com/assets/boss-ceo-romance-2025-og.jpg',
      og_image_alt: 'Boss billionaire romance book covers 2025 collage',
    },
    breadcrumb: ['Home', 'Tropes', 'Boss & CEO Romance'],
  },
  intro:
    "Craving a **boss romance** where a CEO's boardroom commands turn into bedroom promises? This 2025 guide rounds up the best **billionaire boss romance novels**—from fake-fiancée contracts to enemies-to-lovers mergers—all with free first chapters and offline mode. Scroll down, pick your power play, and let the corporate sparks fly.\n\nCheck our [best billionaire romance books 2025](/hub/best-billionaire-romance-books) list or discover how to [read billionaire romance online free](/hub/billionaire-romance-read-online).",
  toc: [
    { id: 'boardroom-power-plays', title: 'Boardroom Power Plays' },
    { id: 'fake-love-contracts', title: 'Fake Love & Contracts' },
    { id: 'enemies-to-lovers-ceos', title: 'Enemies-to-Lovers CEOs' },
    { id: 'office-affairs', title: 'Office Affairs & Forbidden Touches' },
    { id: 'corporate-secrets', title: 'Corporate Secrets & Scandal' },
  ],
  sections: [
    {
      id: 'boardroom-power-plays',
      title: 'Boardroom Power Plays',
      angle: 'Negotiations end when chemistry begins.',
      copy: "In **billionaire CEO romance books**, stock prices and heart rates rise together. **Crash of Hearts**, **Faking It in Chicago**, and **Mr. Silver's Secret** mix hostile takeovers, glass-wall offices, and declarations hot enough to melt any quarterly report. Catch the next release in our [boss romance shelf](/hub/boss-ceo-romance).",
      bookCards: [
        {
          title: 'Crash of Hearts',
          hook: 'Wedding-day sabotage sparks a forbidden office affair.',
          slug: 'crash_of_hearts',
        },
        {
          title: 'Faking It in Chicago',
          hook: 'A fake engagement turns steamy under city lights.',
          slug: 'faking_it_in_chicago',
        },
        {
          title: "Mr. Silver's Secret",
          hook: 'An icy CEO melts for the intern who defies him.',
          slug: 'mr_silvers_secret',
        },
      ],
    },
    {
      id: 'fake-love-contracts',
      title: 'Fake Love & Contracts',
      angle: 'Paper promises—real passion.',
      copy: 'A **fake relationship billionaire romance** signs away hearts for profit—until feelings breach the NDA. **Be My Wife Today**, **Binding Clause**, and **Marriage by Monday** prove that staged affection plus paparazzi equals instant combustion. Browse the full trope list [here](/hub/billionaire-romance).',
      bookCards: [
        {
          title: 'Be My Wife Today',
          hook: 'A paper marriage becomes anything but business.',
          slug: 'be_my_wife_today',
        },
        {
          title: 'Marry Me or Explain This Mess',
          hook: 'Coffee disaster leads to fake engagement with demanding CEO.',
          slug: 'marry_me_or_explain_this_mess',
        },
        {
          title: 'His Forgotten Wife',
          hook: 'Mysterious husband claims her past on a private island.',
          slug: 'his_forgotten_wife',
        },
      ],
    },
    {
      id: 'enemies-to-lovers-ceos',
      title: 'Enemies-to-Lovers CEOs',
      angle: 'Rivalry heats the merger.',
      copy: '**Espresso Empire**, **Hostile Takeover**, and **Crash & Burn** deliver boardroom barbs that morph into midnight truces. For more **billionaire enemies to lovers** drama, see the rage-to-romance collection [here](/hub/billionaire-romance).',
      bookCards: [
        {
          title: 'Espresso Empire',
          hook: 'Caffeine wars brew explosive chemistry.',
          slug: 'espresso_empire',
        },
        {
          title: "Tempting My Father's Rival",
          hook: "Forbidden alliance with daddy's enemy ignites revenge and desire.",
          slug: 'tempting_my_fathers_rival',
        },
        {
          title: 'That Wolf I Used To Own',
          hook: 'Former secretary returns as CEO to face her controlling ex-boss.',
          slug: 'that_wolf_i_used_to_own',
        },
      ],
    },
    {
      id: 'office-affairs',
      title: 'Office Affairs & Forbidden Touches',
      angle: "HR can't police desire.",
      copy: "**My Controlling Boss**, **The Billionaire's Watch**, and **Overtime Secrets** prove that emails can ignite as fast as elevator kisses. More **office billionaire romance** drops every Tuesday—peek [here](/hub/boss-ceo-romance).",
      bookCards: [
        {
          title: 'My Controlling Boss',
          hook: 'A fake-fiancée gig unleashes real feelings.',
          slug: 'my_controlling_boss',
        },
        {
          title: "The Billionaire's Watch",
          hook: 'Danger—and desire—under elite protection.',
          slug: 'the_billionaires_watch',
        },
        {
          title: 'His Secret Asset',
          hook: 'Undercover mission to expose CEO becomes dangerous obsession.',
          slug: 'his_secret_asset',
        },
      ],
    },
    {
      id: 'corporate-secrets',
      title: 'Corporate Secrets & Scandal',
      angle: 'Power, blackmail, and whispered boardroom confessions.',
      copy: '**Secrets of Horizon Gate**, **Crimson Obsession**, and **Bloodlit Whispers** add a shadowy edge to **arrogant boss romance novels**. Dive into darker dossiers [here](/hub/billionaire-romance).',
      bookCards: [
        {
          title: 'Secrets of Horizon Gate',
          hook: 'Sabotage and passion spark in a desert tech fortress.',
          slug: 'secrets_of_horizon_gate',
        },
        {
          title: 'Crimson Obsession',
          hook: 'Revenge paints love in shades of red.',
          slug: 'crimson_obsession',
        },
        {
          title: 'Bloodlit Whispers',
          hook: 'A captive songbird softens a monster in Armani.',
          slug: 'bloodlit_whispers',
        },
      ],
    },
  ],
  faq: [
    {
      q: 'Where can I read boss romance books online free?',
      a: 'NanoReads offers free first chapters of boss romance books and rotating cost-free serials each week.',
    },
    {
      q: 'Do apps let me filter CEO romance by heat level?',
      a: 'Yes—use NanoReads filters to find low-steam office tension or explicit billionaire-boss heat.',
    },
    {
      q: 'How often are new boss romance titles added?',
      a: 'New CEO and boss romances land every Friday; this page refreshes weekly.',
    },
  ],
  updatedOn: '2025-06-09',
};

export const BossCeoRomanceHub: React.FC = () => {
  return <Hub data={hubData} hubName="boss-ceo-romance" />;
};
